import React, { useContext } from 'react';
import c from 'classnames';
import CommentCoreBadgeList from '../../../coreBadge/CoreBadgeList/presets/CommentCoreBadgeList';
import { Props as CommentProps } from '../../presets/Comment';
import { CommentContext } from '../../CommentContext';
import FooterRowLayout from '../../layouts/FooterRowLayout';
import { useButtonConditionals } from './useButtonConditionals';
import LikeButton from '../LikeButton';
import AwardBadgeButton from '../AwardBadgeButton';
import ReplyButton from '../ReplyButton';
import s from './CommentFooter.scss';

export type Props = Pick<CommentProps, 'canPostComment' | 'className'>;

/** All of our comment interaction buttons in a nice row. Includes liking, replying, badge awarding, and editing. */
const CommentFooter: React.FC<Props> = ({ canPostComment = true, className }) => {
  const { comment, isCommentVisible } = useContext(CommentContext);
  const { showReplyButton, showAwardBadgeButton, showLikeButton } = useButtonConditionals({
    canPostComment,
  });

  if (!isCommentVisible) {
    return null;
  }

  return (
    <FooterRowLayout
      className={className}
      blocks={[
        showReplyButton && (
          <ReplyButton key="reply-button" className={c(s['action'], s['action-styled'])} />
        ),
        showLikeButton && (
          <LikeButton key="like-button" className={c(s['action'], s['action-styled'])} />
        ),
        showAwardBadgeButton && (
          <AwardBadgeButton
            key="award-badge-button"
            className={c(s['action'], s['action-styled'])}
          />
        ),
        <CommentCoreBadgeList comment={comment} key="badges" />,
      ]}
    />
  );
};
CommentFooter.displayName = 'CommentFooter';

export default CommentFooter;
